/*
 * --------------------------------------------------------------------
 * File: \src\app\mapSlice.js
 * Created: Wednesday, 25th September 2024 12:26:47 pm
 * Modified: Wednesday, 25th September 2024 12:26:47 pm
 * Author: Mohamed Kamil Bin Mansor
 * 
 * Copyright (c) 2024 - System Consultancy Services Sdn. Bhd.
 * --------------------------------------------------------------------
 */


import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sideContent: null, ///Content for Left and Right Menu
  sideContent2: null,
  sideSubContent: null,
  sideLoading: false,///Create loading UI if true
  sideSubLoading: false,   //Loading UI for right panel specifically kemudahan masyarakat
  currentLocation: null,
  sideLegend: null,
  showSideDetail: false,
  sideInfoWorker: null,
};

export const mapSlice = createSlice({
  name: "map",
  initialState,
  reducers: {
    setSideContent: (state, action) => {
      state.sideContent = action.payload;
    },
    setSideSubContent: (state, action) => {
      state.sideSubContent = action.payload;
    },
    setSideContent2: (state, action) => {
      state.sideContent2 = action.payload;
    },
    setSideLoading: (state, action) => {
      state.sideLoading = action.payload;
    },
    setSideSubLoading : (state,action) => {
      state.sideSubLoading = action.payload;
    },
    setCurrentLocation: (state, action) => {
      state.currentLocation = action.payload;
    },
    setSideLegend: (state,action) => {
      state.sideLegend = action.payload
    },
    setShowSideDetail: (state,action) => {
      state.showSideDetail = action.payload
    },
    setSideInfoWorker: (state,action) => {
      state.sideInfoWorker = action.payload
    },
    // setPoint: (state, action) => {
    //   state.point = {
    //     ...state.point,
    //     ...action.payload,
    //   };
    // },
  },
});

export const {
  setSideContent,
  setSideLoading, 
  setSideSubLoading,
  setSideSubContent,
  setSideContent2,
  setCurrentLocation,
  setSideLegend,
  setShowSideDetail,
  setSideInfoWorker
  // setPoint 
} = mapSlice.actions;

// export const getPoint = (state) => state.map.point;
export const getSideContent = (state) => state.map.sideContent;
export const getSideSubContent = (state) => state.map.sideSubContent;
export const getSideContent2 = (state) => state.map.sideContent2;
export const getSideLoading = (state) => state.map.sideLoading;
export const getSideSubLoading = (state) => state.map.sideSubLoading;
export const getCurrentLocation = (state) => state.map.currentLocation;
export const getSideLegend = (state) => state.map.sideLegend;
export const getShowSideDetail = (state) => state.map.showSideDetail;
export const getSideInfoWorker = (state) => state.map.sideInfoWorker;

export default mapSlice.reducer;